const STEP = {
    HOW_IT_WORKS: 'howItWorks',
    PRICE_YOUR_RENTAL: 'priceYourRental',
    VERIFY_SECURITY_DEPOSIT: 'verifySecurityDeposit',
    ONLINE_TOOLS: 'onlineTools',
    CONFIRMATION: 'confirmation',
    JOURNEY_MAP_AFTER_LISTING: 'journeyMapAfterListing',
};

const PROGRESS_STEP = {
    PRICE_YOUR_RENTAL: 'priceYourRental',
    VERIFY_SECURITY_DEPOSIT: 'verifySecurityDeposit',
    ONLINE_TOOLS: 'onlineTools',
    CONFIRMATION: 'confirmation',
};

const PROGRESS_STEP_CONFIG = [
    {
        key: PROGRESS_STEP.VERIFY_SECURITY_DEPOSIT,
        label: 'Terms',
    },
    {
        key: PROGRESS_STEP.ONLINE_TOOLS,
        label: 'Tools',
    },
    {
        key: PROGRESS_STEP.CONFIRMATION,
        label: 'Review',
    },
];

const DEEP_LINK_STEP = {
    [PROGRESS_STEP.PRICE_YOUR_RENTAL]: STEP.PRICE_YOUR_RENTAL,
    [STEP.SECURITY_DEPOSIT]: STEP.SECURITY_DEPOSIT,
    [PROGRESS_STEP.ONLINE_TOOLS]: STEP.ONLINE_TOOLS,
    [PROGRESS_STEP.CONFIRMATION]: STEP.CONFIRMATION,
};

export {
    PROGRESS_STEP_CONFIG,
    DEEP_LINK_STEP,
    PROGRESS_STEP,
    STEP,
};
